export default "__VITE_ASSET__BPlE$TQL__"